import script from "./PayComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PayComponent.vue?vue&type=style&index=0&id=3930fefc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3930fefc"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QInput,QBanner,QSpinner});
